import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Container = styled.div`
  ${'' /* background: #e5e5e5; */}
  padding: 11px 16px;
  margin: 0;

  .header {
    color: #333333;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 21px;
  }

  ${mediaQuery.desktop`
  ${'' /* background: #e5e5e5; */}
  padding: 20px 72px;
  margin: 0;
  `}
`;

export const Tabs = styled.div`
  ${mediaQuery.desktop`
margin-top: 20px;
`}
  margin-top: 20px;

  .tab {
    display: inline-block;
    cursor: pointer;
    margin-right: 33px;
    text-align: center;
    color: #4f4f4f;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .tab_title {
    list-style: none;
    padding: 0px;
    margin: 0px;
    border: none;
    width: 100%;
    display: flex;
    align-items: center;
    align-content: center;
    text-align: center;
  }

  .tab_active {
    display: inline-block;
    cursor: pointer;
    margin-right: 33px;
    background: #edfafa;
    border-radius: 5px;
    color: #549a9a;
    height: 33px;
    width: auto;
    padding-left: 21px;
    padding-right: 21px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    text-align: center;
  }

  .content {
    display: none;
  }

  ${
    '' /* .tab_content {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    margin-top: 18px;
  } */
  }
`;

export const ProfileContainer = styled.div`
  margin-top: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin-top: 18px;

  ${mediaQuery.desktop`
margin-top: 20px;
background: #fff;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    margin-top: 18px;
`}

  .profile_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 22px 15px;
  }

  ${mediaQuery.desktop`
  .profile_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 22px 24px;
  }
  `}

  .profile_title {
    font-weight: 500;
    font-size: 18px;
    color: #4f4f4f;
    margin: 0;
    padding: 0;
  }

  .profile_button {
    width: 96px;
    cursor: pointer;
    background: #549a9a;
    border-radius: 5px;
    border: none;
    outline: none;
    height: 55px;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
  }

  .profile_save_button {
    width: auto;
    cursor: pointer;
    background: #549a9a;
    border-radius: 5px;
    border: none;
    outline: none;
    height: 55px;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
  }

  .active {
    display: none;
  }

  .profile_edit {
    display: flex;
  }

  .profile_cancel_button {
    background-color: #fff;
    color: #549a9a;
    border: 1px solid #549a9a;
    margin-right: 20px;
    cursor: pointer;
    height: 55px;
    font-weight: 600;
    font-size: 18px;
    border-radius: 5px;
  }

  .profile_form {
    margin-top: 5px;
    padding: 15px;
  }

  ${mediaQuery.desktop`
  .profile_form {
    margin-top: 5px;
    padding: 22px 22px;
  }
  `}

  .profile_form_content {
    border-bottom: 1px solid #f2f2f2;
    padding-top: 15px;
    padding-bottom: 15px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 20px;
    align-items: center;
    align-content: center;
  }

  ${mediaQuery.desktop`
  .profile_form_content {
    border-bottom: 1px solid #f2f2f2;
    padding-top: 15px;
    padding-bottom: 15px;
    display: grid;
    grid-template-columns: 200px auto;
    grid-gap: 20px;
    align-items: center;
    align-content: center;
  }
  `}

  .profile_form_label {
    font-weight: 500;
    font-size: 15px;
    color: #4f4f4f;
  }

  .profile_avatar_upload {
    position: relative;
    max-width: 250px;
  }

  .profile_icon {
    position: absolute;
    left: 24%;
    top: 52%;
    width: 30px;
    height: 30px;
    background-color: #549a9a;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    cursor: pointer;
  }

  .profile_image {
    width: 79px;
    height: 79px;
    border-radius: 100%;
    object-fit: cover;
  }

  .profile_input_content {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
  }

  ${mediaQuery.desktop`
  .profile_input_content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
  }
  `}

  .button_container {
    margin-top: 20px;
  }

  ${mediaQuery.desktop`
  .button_container {
    margin-top: 0px;
  }
  `}

  .profile_image_default {
    width: 79px;
    height: 79px;
    border-radius: 100%;
    background: #828282;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    font-weight: 600;
    font-size: 18px;
  }
`;

export const PasswordContainer = styled.div`
  .password_form_content {
    border-bottom: 1px solid #f2f2f2;
    padding-top: 15px;
    padding-bottom: 15px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 20px;
  }

  ${mediaQuery.desktop`
.password_form_content {
  border-bottom: 1px solid #f2f2f2;
  padding-top: 15px;
  padding-bottom: 15px;
  display: grid;
  grid-template-columns: 200px auto;
  grid-gap: 20px;
}
`}

  .password_form_label {
    font-weight: 500;
    font-size: 15px;
    color: #4f4f4f;
  }

  .password_container {
    width: auto;
  }

  ${mediaQuery.desktop`
  .password_container {
    width: 571px;
  }
  `}
`;

export const Header = styled.div`
  display: none;
  position: absolute;
  top: 2.5%;
  z-index: 4;
  font-weight: 600;
  font-size: 24px;
  color: #003232;

  ${mediaQuery.desktop`
  display: block;
  position: absolute;
  top: 2.5%;
  z-index: 4;
  width: 65%;
  font-weight: 600;
  font-size: 24px;
  color: #003232;
`}
`;

export const Table = styled.div`
  width: 100%;
  overflow: auto;
  border: 1px solid #e0e0e0;
  margin-top: 21px;
  border-radius: 4px;

  table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;

    thead {
      background: #fff;
      height: 44px;
      border-bottom: 1px soild #e0e0e0;

      tr th {
        text-align: left;
        color: #333333;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        padding-left: 24px;
      }
    }

    tbody {
      background: #fff;

      tr {
        :nth-child(odd) {
          background: #fafafa;
          border-bottom: 1px solid #e0e0e0;
          border-top: 1px solid #e0e0e0;
        }
      }

      tr td {
        padding: 24px;
      }

      .id {
        white-space: nowrap;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
      }

      .date {
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        white-space: nowrap;
      }

      .price {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
      }

      p {
        margin: 0;
        padding: 0;
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        white-space: nowrap;
      }

      h4 {
        margin: 0;
        padding: 0;
        color: #549a9a;
        font-size: 14px;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
        white-space: nowrap;
      }

      .non_active {
        margin: 0;
        padding: 0;
        color: #bdbdbd;
        font-size: 14px;
        font-weight: 500;
        text-decoration: underline;
        white-space: nowrap;
      }

      .link {
        color: #549a9a;
        font-size: 16px;
        font-weight: 700;
        text-transform: capitalize;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
`;

export const Review = styled.div`
  .star_container {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 11px;

    .star {
      font-size: 2rem;
      color: #ccc;
      cursor: pointer;
    }

    .star.filled {
      color: #f2994a; /* Change this to the desired filled star color */
    }
  }
  textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 14px;
    border: 1px solid #d0d5dd;
    border-radius: 8px;
    margin-top: 8px;
    margin-bottom: 24px;
    font-size: 16px;
    font-family: 'Poppins', sans-serif;

    &:placeholder {
      color: #bdbdbd;
      font-size: 12px;
      font-weight: 400;
    }

    &:focus {
      outline: none;
      border: 2px solid #549a9a;
    }
  }
`;

export const SellerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;


  img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 100%;
  }

  .seller_name {
    color: #333333;
    font-size: 16px;
    font-weight: 400
  }

  xt-decoration: underline;
  }

 
`;
